import {initTrustbars} from "../../../default/global/js/trustbar";
import {getChildrenClassForNestedItems} from "../../../default/global/js/nav";
import {closeFilterBox, initFilter, moveFilterSortLine} from "../../../default/global/js/filter";
import {initActionClicks, initFormSubmitChanges, initFormSubmitClicks} from "../../../default/global/js/actionClick";
import {focusInputGroups} from "../../../default/global/js/checkInputGroups";
import {stickyHeader} from "../../../default/global/js/stickyheader";
import {triggerFavoritesBtns} from "../../../default/global/js/favorites";
import {initQuantitySpinners} from "../../../default/global/js/quantitySpinner";
import hoverintent from "../../../default/global/js/hoverintent";
import {initSlideshows} from "../../../default/global/js/slideshow";
import {openFullscreenGallery} from "../../../default/global/js/fullscreengallery";
import {stickyBox} from "../../../default/global/js/stickyBox.js";
import {buildMobileMenu, hideMobileMenu, showMobileMenu} from "../../../default/global/js/mobilemenu";
import {
    excludeModal,
    triggerConfirmModalLink,
    triggerModal,
    triggerOpenLinkInModal,
    triggerOpenTextInModal
} from "../../../default/global/js/modal";
import {triggerBasketBtns, triggerUpdateBasketView} from "../../../default/global/js/basket";
import {initToggleSlide} from "../../../default/global/js/toggle";
import {initItemlistSlider} from "../../../default/global/js/itemListSlider";
import {initLazyImages} from "../../../default/global/js/lazyImages";
import {setSrcVideos} from "../../../default/global/js/video";
import {initScrollbars} from "../../../default/global/js/scrollbar";
import {isTouchDevice} from "../../../default/global/js/touchDevice";
import {
    hideAllCustomSelect,
    hideCustomSelect,
    initCustomSelects,
    updateCustomSelectRangeFilterAction
} from "../../../default/global/js/customSelect";
import {initJumpmarks} from "../../../default/global/js/jumpmark";
import {initSearchItems} from "../../../default/global/js/searchItems";
import {trimInputValues} from "../../../default/global/js/formValidator";
import {addLoadingClassAfterSubmit} from "../../../default/global/js/utilities/updateClasses";
import {initPasswordFields} from "../../../default/global/js/password";
import {lottieLoader} from "../../../default/global/js/lottieLoader";
import {initSlidecontents} from "../../../default/global/js/slidecontent";
import {initFlashmessages} from "../../../default/global/js/flashmessages";
import {addTableWrapper} from "../../../default/global/js/tableWrapper";
import {initPhoneCountryFields} from "../../../default/global/js/phoneCountryField";
import {initInputBody} from "../../../default/global/js/inputfile";
import initDcOrder from "../../../default/global/js/dcorder";
import {initShowMoreRatings} from "../../../default/global/js/rating";
import {initImageGallery} from "../../../default/global/js/imageGallery";
import {initInputMaskDate} from "../../../default/global/js/inputMaskDate";
import {initRecaptchaForms} from "../../../default/global/js/recaptchaForm";
import {initAjaxCollectionFilter} from "../../../default/global/js/ajaxCollectionFilter";
import {initDatepicker} from "../../../default/global/js/datepicker";
import {initAddressAutocomplete, initShippingAddressAutocomplete} from "../../../default/global/js/addressAutocomplete";
import {initContentTabs} from "../../../default/global/js/contentTabs";
import {initHistorySlider} from "../../../default/global/js/history";
import {initAjaxFormApi} from "../../../default/global/js/ajaxFormApi";
import {initScrollActivate} from "../../../default/global/js/scrollactivate";
import {initRangeslider} from "../../../default/global/js/rangeSlider";
import {initFlyout} from "../../../default/global/js/flyoutMenu";
import {closeInfoPopup} from "./custom/infoPopup";
import {Tooltip} from "../../../default/global/js/tooltip";
import {crossSellerCheckBoxes} from "./custom/crosssellerCheckbox";
import {specialCheckboxListener} from "./custom/specialCheckboxListener";


window.addEventListener("load", (event) => {
    const mobileMenu = document.querySelector('.mobileMenu');
    const mobileMenuToggle = document.getElementById("js-toggleNavigation");
    const overlay = document.getElementById("overlay");
    const IsTouchDevice = isTouchDevice();
    const stickyHeaderArea = document.querySelector('.headerMain');

    let breakPointSM = 1024;
    let sendFavoriteByJS = false;
    let sendItemToBasketByJS = false;
    let updateBasketByJS = false;

    if (typeof GLOBALS!== "undefined") {
        breakPointSM = GLOBALS.gridBreakpoints.sm;
        sendFavoriteByJS = GLOBALS.sendFavoriteByJS;
        sendItemToBasketByJS = GLOBALS.sendItemToBasketByJS;
        updateBasketByJS = GLOBALS.updateBasketByJS;
    }

    if (mobileMenu && mobileMenuToggle && overlay) {
        buildMobileMenu(mobileMenu);
        mobileMenuToggle.addEventListener("click", function () {
            if (mobileMenuToggle.classList.contains("is-active")){
                hideMobileMenu(mobileMenu, overlay, mobileMenuToggle);
            }
            else{
                showMobileMenu(mobileMenu, overlay, mobileMenuToggle);
            }
        });

        overlay.addEventListener("click", function () {
            hideMobileMenu(mobileMenu, overlay, mobileMenuToggle);
            for (let filterbox of document.querySelectorAll('.filterBox')) {
                closeFilterBox(filterbox);
            }
        });
    }

    initTrustbars();

    initFilter();

    initActionClicks();

    initFormSubmitClicks();

    initFormSubmitChanges();

    trimInputValues();

    focusInputGroups();

    initInputBody();

    initPhoneCountryFields();

    stickyHeader(stickyHeaderArea);

    if (window.outerWidth < breakPointSM) {
        for (let parent of document.querySelectorAll('.navgroup > ul > li')) {
            getChildrenClassForNestedItems(parent);
        }
    }

    if (sendFavoriteByJS) {
        triggerFavoritesBtns();
    }

    if (sendItemToBasketByJS) {
        triggerBasketBtns();
    }

    if (updateBasketByJS) {
        triggerUpdateBasketView();
    }

    triggerModal();
    excludeModal();
    triggerOpenLinkInModal();
    triggerConfirmModalLink();
    triggerOpenTextInModal();

    initQuantitySpinners();

    initToggleSlide();

    if (!IsTouchDevice) {
        for (let el of document.querySelectorAll('.itembox,.iconbarItem')) {
            hoverintent(el);
        }
    }
    for (let el of document.querySelectorAll('.js-mainNavigation li')) {
        hoverintent(el);
    }

    setSrcVideos();

    initSlideshows();

    initImageGallery();

    initScrollbars();

    initSlidecontents();

    initLazyImages();

    initItemlistSlider(document.querySelectorAll('.itemboxList.swiper'),{
        breakpointItems: {
            xs: 1.2,
            sm: 2,
            md: 3,
            lg: 4,
            xlg: 4
        }
    });

    initCustomSelects();

    initRangeslider(document,function (e){
        if(e.slider.closest(".js-customSelect")){
            updateCustomSelectRangeFilterAction(e.slider.closest(".js-customSelect"),e.value);
        }
    });

    function initializeTooltips() {
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-toggle="tooltip"]'));
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl);
        });
    }

    initializeTooltips();

    var tooltipObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1) {
                    if (node.matches('[data-toggle="tooltip"]') || node.querySelector('[data-toggle="tooltip"]')) {
                        initializeTooltips();
                    }
                }
            });
        });
    });

    tooltipObserver.observe(document.body, { childList: true, subtree: true });

    initSearchItems(document.querySelectorAll('.js-searchInput'));

    initFlashmessages();

    let offsetTopJumpmarks = 0;
    if (stickyHeaderArea) {
        offsetTopJumpmarks = stickyHeaderArea.clientHeight;
    }

    if (typeof GLOBALS!== "undefined") {
        if(GLOBALS.offsetTopJumpmarks){
            offsetTopJumpmarks += GLOBALS.offsetTopJumpmarks;
        }
    }

    initJumpmarks(offsetTopJumpmarks);

    for (let item of document.querySelectorAll(".js-openGallery")) {
        item.addEventListener('click', function (event) {
            openFullscreenGallery(item);
        });
    }

    let offsetTopStickyBox = 30;
    if (stickyHeaderArea) {
        offsetTopStickyBox += stickyHeaderArea.clientHeight;
    }

    for (let pinBox of document.querySelectorAll(".js-stickyBox")) {
        stickyBox(pinBox, {
            offsetTop: offsetTopStickyBox
        });
    }
    lottieLoader();

    addLoadingClassAfterSubmit();
    initPasswordFields();

    addTableWrapper();

    initDcOrder();

    initShowMoreRatings();

    initInputMaskDate();

    initRecaptchaForms();

    initAjaxCollectionFilter();

    initDatepicker();

    // Initialize address autocomplete for checkout
    initAddressAutocomplete();
    initShippingAddressAutocomplete();

    initHistorySlider();

    initContentTabs();

    initFlyout();

    initAjaxFormApi();

    initScrollActivate();

    window.main = {
        hideAllCustomSelect: function (){
            hideAllCustomSelect();
        },
        hideCustomSelect: function (select){
            hideCustomSelect(select);
        }
    }

    const observer = new MutationObserver(function(mutationsList, observer) {
        const subnav = document.querySelector('.mainContent .subnav');
        const itemlistView = document.querySelector('.itemlistView, .itemListView');
        const filterSortLine = document.querySelector('.filterSortLine, .filter-sort-line');

        if (subnav && itemlistView && filterSortLine) {
            moveFilterSortLine();
            observer.disconnect();
        }
    });

    observer.observe(document, { childList: true, subtree: true });

    window.addEventListener('resize', function() {
        moveFilterSortLine();
    });


    closeInfoPopup();

    crossSellerCheckBoxes();

    specialCheckboxListener();

});
